import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SocialGameUser } from '../models/social-game-user';
import { Message } from 'infrastructure/lib/src/models/messages';
import { Conversation } from 'infrastructure/lib/src/models/conversation';
import { Platform } from '@ionic/angular';

export enum ModeState {
  Off,
  ToggledOn,
  Error,
  On,
};

export enum weatherStates {
  sunny = 'sunny',
  cloudy = 'cloudy',
  rainy = 'rainy',
  thunderstorm = 'thunderstorm',
  snow = 'snow',
}

export interface playerCoords{
  x: number;
  y: number;
}

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  public $loggedIn = new BehaviorSubject<boolean>(false);
  static $gpsModeState = new BehaviorSubject<ModeState>(ModeState.Off);
  static $onlineModeState = new BehaviorSubject<ModeState>(ModeState.Off);
  static $weatherConnectivityState = new BehaviorSubject<ModeState>(ModeState.ToggledOn);
  static $musicPlaying = new BehaviorSubject<Boolean>(true);
  static $playerXY = new BehaviorSubject<playerCoords>({x:0, y:0});
  static $openModalsCount = new BehaviorSubject<number>(0);
  static $previousModalsCount = new BehaviorSubject<number>(0);
  static $activeScenes = new BehaviorSubject<Array<Phaser.Scene>>([]);
  public static $currentUser = new BehaviorSubject<SocialGameUser>({
      username: "",
      userId: "",
      bio: "",
      gameItems: [],
      inventory: {},
      type: "GameUser",
      isTrailing: [],
      isTrailedBy: [],
    });
  static modeState = ModeState;
  static weatherStates = weatherStates;
  static $conversation = new BehaviorSubject<Message[]>([]);
  static $conversationsMetadata = new BehaviorSubject<Array<Conversation>>([]);
  static platform: Platform;
  static device: string;
  static zoom = 1.3;

  public getGpsModeState(){
    return GlobalService.$gpsModeState;
  }

  public getWeatherConnectivityState(){
    return GlobalService.$weatherConnectivityState;
  }

  public getModeStateEnum(){
    return GlobalService.modeState;
  }

  public getOnlineModeState(){
    return GlobalService.$onlineModeState;
  }

  public getMusicPlaying() {
    return GlobalService.$musicPlaying;
  }

  static incrementModalCount(){
    GlobalService.$previousModalsCount.next(GlobalService.$openModalsCount.getValue());
    GlobalService.$openModalsCount.next(GlobalService.$openModalsCount.getValue() + 1);
  }

  static decrementModalCount(){
    GlobalService.$previousModalsCount.next(GlobalService.$openModalsCount.getValue());
    GlobalService.$openModalsCount.next(GlobalService.$openModalsCount.getValue() - 1);
  }

}